export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
  if (!pathname) return false
  const current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  const totalSlashCurrent = current.split('/').length
  const totalSlashUrl = url.split('/').length

  if (current.startsWith(url) && totalSlashCurrent === totalSlashUrl) {
    return true
  }

  // if (current.indexOf(url) > -1) {
  //   return true
  // }

  return false
}
